import http from '../../../../libs/http'
export default (payload = {
  name: '',
  code: '',
  state: true
}) => http.post(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/order-state`, payload)
